const config = state => state.app.config
const palette = state => state.app.config.palette
const isLoading = state => state.app.isLoading

export {
  config,
  palette,
  isLoading,
}
